import { Component } from '@angular/core';

@Component({
  selector: 'app-push-live-sidebar-layout',
  templateUrl: './push-live-sidebar-layout.component.html',
  styleUrl: './push-live-sidebar-layout.component.css',
})
export class PushLiveSidebarLayoutComponent {}
